import { connect } from 'react-redux';
import AppComponent from './App';
import {
    selectSelectedMembership,
    selectTheme,
    selectOrganizations,
} from './duck/selectors';
import {
    logout,
    updateWhoAmIAndLogoutIfAuthExpired,
    initApp,
} from './duck/operations';
import { fetchActiveReservations } from './pages/ReservationsPage/duck/operations';
import {
    selectUnauthorizedActionAttempted,
    selectUnauthorizedUrl,
} from './pages/ErrorPage/duck/selectors';
import { updateFcmToken } from './pages/ProfilePage/duck/notifications/operations';
import { updateNotificationPermission } from './pages/ProfilePage/duck/notifications/operations';
import { AppDispatch, State } from '../state/store';
import { clearErrors } from './pages/ErrorPage/duck/reducer';
import { findCars } from './pages/SearchPage/duck/operations';

const mapStateToProps = (state: State) => {
    return {
        theme: selectTheme(state),
        organizations: selectOrganizations(state),
        selectedMembership: selectSelectedMembership(state),
        unauthorizedActionAttempted: selectUnauthorizedActionAttempted(state),
        unauthorizedUrl: selectUnauthorizedUrl(state),
    };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
        logout: () => dispatch(logout()),
        fetchActiveReservations: (preloadAll: boolean) =>
            dispatch(fetchActiveReservations(preloadAll)),
        logoutIfAuthExpired: (fetchUserInfoIfLoggedIn?: boolean) =>
            dispatch(
                updateWhoAmIAndLogoutIfAuthExpired(fetchUserInfoIfLoggedIn)
            ),
        initApp: () => dispatch(initApp()),
        clearErrors: () => dispatch(clearErrors()),
        findCars: () => dispatch(findCars()),
        updateFcmToken: (
            fcmToken: string,
            deviceId: string,
            deviceName: string
        ) => dispatch(updateFcmToken(fcmToken, deviceId, deviceName)),
        rejectNotificationPermission: () =>
            dispatch(updateNotificationPermission(false)),
    };
};

const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);

export default App;
